module.exports = __webpack_public_path__ + "img/blog-3-pic-1.15bdf382.webp";